var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.357,
    height: 93.126,
    viewBox: "0 0 22.357 93.126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4149.682 1039.907) rotate(-90)"
  }, /*#__PURE__*/React.createElement("line", {
    y1: 15.938,
    x2: 43.354,
    transform: "translate(949.99 4152.891)",
    fill: "none",
    stroke: "#777776",
    strokeLinecap: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.354,
    y1: 15.938,
    transform: "translate(993.344 4152.891)",
    fill: "none",
    stroke: "#777776",
    strokeLinecap: "round",
    strokeWidth: 5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/ArrowLeft.0b9e75c9cbf3de480d3f618d1186de33.svg";
export { ForwardRef as ReactComponent };